"use strict";
import { getRequest, postRequest } from "@/services/RequestService";
import { getImage } from "./RequestService";

export const getContentCoverages = async () => {
  const base_route = `premia/tba/fire/contents`;
  const response = await getRequest(base_route);
  return response;
};

export const getContentCoverageDetail = async (id) => {
  const base_route = `premia/tba/fire/contents/${id}/show`;
  const response = await getRequest(base_route);
  return response;
};

export const getActivityLogs = async (id) => {
  const base_route = `premia/tba/fire/contents/${id}/logs`;
  const response = await getRequest(base_route);
  return response;
};

export const storeDetail = async (request) => {
  const base_route = `/premia/tba/fire/contents`;
  const response = await postRequest(base_route, request);
  return response;
};

export const removePhoto = async (id) => {
  const base_route = `/premia/tba/fire/contents/${id}/remove`;
  const response = await postRequest(base_route, null);
  return response;
};

export const storeCertificateNoRequest = async (request) => {
  const base_route = `/premia/tba/fire/contents/${request.id}/certificate`;
  const response = await postRequest(base_route, request);
  return response;
};
